<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $route.params["dv_id"] ? "Edit" : "Add" }} IP List
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-4">
          <label for="cinemas-list mb-1" class="font-weight-bold">Cinema</label>
          <div class="dropdown-curve-container">
            <multiselect
              id="cinemas-list"
              v-model="selectedCinemaId"
              placeholder="Cinema"
              :options="cinemasList"
              label="cine_name"
              track-by="cine_id"
              :multiple="false"
              select-label="Select"
              deselect-label="Remove"
              @select="handleCinemaChange($event)"
            >
            </multiselect>
          </div>
        </div>
      </div>

      <p class="text-left font-weight-bold my-2">IP Lists</p>
      <table
        class="swc-report-table w-50"
        border="1"
        style="table-layout: auto; background: white; zoom: 0.9"
      >
        <thead>
          <tr class="bg-lightprimary text-blue">
            <th>S no.</th>
            <th>IP Address</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ip, index) in allowedIps" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="ip.ip_address"
                  name="ip_address"
                  :id="`ip_address_${index}`"
                  v-validate="'required'"
                />
              </div>
            </td>
            <td>
              <button
                class="btn-sm add-btn bg-transparent border-0"
                @click="handleRemoveIp(index)"
              >
                <img
                  src="@/assets/img/icons/trash.svg"
                  height="24"
                  width="24"
                />
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                class="btn-sm add-btn bg-transparent border-0"
                @click="handleAddIp"
              >
                <img src="@/assets/img/icons/plus.svg" height="24" width="24" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <button class="my-2 btn-blue btn-sm" @click="handleSubmit">Submit</button>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
export default {
  data() {
    return {
      allowedIps: [{ ip_address: "" }],
      selectedCinemaId: { cine_id: null },
      cinemasList: [],
    };
  },
  beforeMount() {
    this.fetchCinemas();
    if (this.$route.params["cinema_id"]) {
      this.selectedCinemaId.cine_id = this.$route.params["cinema_id"];
      this.fetchAllowedIps();
    }
  },
  methods: {
    handleAddIp() {
      this.allowedIps.push({ ip_address: "" });
    },
    handleRemoveIp(index) {
      if (this.allowedIps.length == 1 && index == 0) {
        this.allowedIps[index] = "";
        return;
      }
      this.allowedIps.splice(index, 1);
    },
    async fetchCinemas() {
      try {
        const response = await MasterService.GetCinemasByRoles();

        const { data } = response;

        if (!data || !data.status || !data.Records.length) {
          this.$toasted.show("Cinemas not found");
        }

        this.cinemasList = data.Records;
        this.fetchAllowedIps();
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllowedIps() {
      try {
        if (!this.selectedCinemaId.cine_id) {
          return this.$toasted.show("Please select a cinema");
        }
        this.allowedIps = [];
        const response = await ExhibitorService.FetchAllowedIps({
          cinema_id: this.selectedCinemaId.cine_id,
        });

        const { data } = response;

        if (data && data.status && data.Records && data.Records.length) {
          this.allowedIps = data.Records;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleCinemaChange() {
      await this.fetchAllowedIps();
    },
    async addAllowedIp() {
      try {
        if (!this.selectedCinemaId || !this.selectedCinemaId.cine_id) {
          this.$toasted.show("Please select a cinema");
          return;
        }
        const response = await ExhibitorService.AddAllowedIps({
          cinema_id: this.selectedCinemaId.cine_id,
          allowedIps: this.allowedIps,
        });

        const { data } = response;
        this.$toasted.show(data.message);
      } catch (error) {
        console.log(error);
      }
    },
    async updateAllowedIp() {
      try {
        if (!this.selectedCinemaId || !this.selectedCinemaId.cine_id) {
          this.$toasted.show("Please select a cinema");
          return;
        }
        const response = await ExhibitorService.UpdateAllowedIps({
          cinema_id: this.selectedCinemaId.cine_id,
          allowedIps: this.allowedIps,
        });

        const { data } = response;
        this.$toasted.show(data.message);
      } catch (error) {
        console.log(error);
      }
    },
    async handleSubmit() {
      if (false && this.$route.params["cinema_id"]) {
        await this.updateAllowedIp();
      } else {
        await this.addAllowedIp();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AllowedIps/addEditAllowedIps.vue